module.exports = __webpack_public_path__ + "static/suyash-namdeo-32aa1c041c912df0876be46233367033.jpg";